export const actionChangeStatusModalInvoice = (statusShow) => ({
    type: 'CHANGE_HANDLE_MODAL_INVOICE',statusShow
});
export const actionChangeSelectOrderModalInvoice = (order) => ({
    type: 'GET_DATA_INVOICE_IN_API_MODAL_INVOICE',order
});
export const actionChangeLoaderModalInvoice = (loader) => ({
    type: 'CHANGE_LOADER_MODAL_INVOICE',loader
});
export const actionChangeLoaderCancelModalInvoice = (cancelLoader) => ({
    type: 'CHANGE_LOADER_CANCEL_MODAL_INVOICE',cancelLoader
});
